// extracted by mini-css-extract-plugin
export default {"chart":"QOLChart_chart__IP1zF","personA":"QOLChart_personA__9cOEh","personB":"QOLChart_personB__XmbAe"};